import Dialog from './Dialog.svelte'

export default Dialog
